import React from 'react';

import { classnames } from '@lumapps/classnames';
import type { ElementRender } from '@lumapps/wrex/types';

import { T_H } from '../../../constants';
import type { THElement } from '../../../types';

import './index.scss';

export const TH: ElementRender<THElement, HTMLTableCellElement> = (props) => {
    const { children, className, elementRef, element, ...forwardedProps } = props;

    const cellClassName = classnames(className, 'wrex-content-th', {
        'wrex-content-th--is-in-selection': element?.isInCellSelection,
    });

    return (
        <th {...forwardedProps} className={cellClassName} scope={element?.headerType} ref={elementRef}>
            {children}
        </th>
    );
};
TH.displayName = T_H;
